import React from 'react';
import { PlusOutlined, RightOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import OnTraccrButton from '../../../../../common/buttons/OnTraccrButton';
import useToggle from '../../../../../common/hooks/useToggle';
import TimeTrackingGridWizardAddCostcodeDrawer from './TimeTrackingGridWizardAddCostcodeDrawer';

export default function TimeTrackingGridWizardCostcodeStep({
  selectedCostcodes,
  setSelectedCostcodes,
  divisions,
  goToNextStep,
  configProps,
  costcodes,
  fetchProjectCostcodes,
}) {
  const { t } = useTranslation();
  const { toggle: toggleAddCostcodeDrawer, isToggled: showAddCostcodeDrawer } = useToggle();
  const pluralText = selectedCostcodes?.length !== 1 ? 'codes' : 'code';
  return (
    <div className="time-tracking-grid-wizard-date-step-container">
      <div className="time-tracking-grid-content-title">Step 2: Add Cost Codes</div>
      <div className="time-tracking-grid-content-description">
        Cost codes become the columns of your grid. Add the {t('Project').toLowerCase()}/cost code combinations
        where hours will be allocated.
      </div>
      <div className="time-tracking-grid-sub-content">
        <div>
          <div className="time-tracking-grid-wizard-costcode-step-count">{selectedCostcodes?.length || 0}</div>
          <div className="time-tracking-grid-wizard-costcode-step-count-text">cost {pluralText} added</div>
        </div>
        <OnTraccrButton
          title={!selectedCostcodes?.length ? 'Add Cost Codes' : 'Add More Cost Codes'}
          iconLeft
          icon={<PlusOutlined />}
          className="time-tracking-grid-wizard-content-button"
          type={!selectedCostcodes?.length ? 'primary' : 'cancel'}
          onClick={toggleAddCostcodeDrawer}
        />
        { !!selectedCostcodes?.length && (
          <OnTraccrButton
            title="Continue"
            onClick={goToNextStep}
            icon={<RightOutlined />}
            className="time-tracking-grid-wizard-content-button"
          />
        )}
      </div>
      <TimeTrackingGridWizardAddCostcodeDrawer
        visible={showAddCostcodeDrawer}
        onClose={toggleAddCostcodeDrawer}
        selectedCostcodes={selectedCostcodes}
        setSelectedCostcodes={setSelectedCostcodes}
        divisions={divisions}
        configProps={configProps}
        costcodes={costcodes}
        fetchProjectCostcodes={fetchProjectCostcodes}
      />
    </div>
  );
}

TimeTrackingGridWizardCostcodeStep.propTypes = {
  selectedCostcodes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setSelectedCostcodes: PropTypes.func.isRequired,
  goToNextStep: PropTypes.func.isRequired,
  divisions: PropTypes.arrayOf(PropTypes.string).isRequired,
  configProps: PropTypes.shape({
    isProjectRequired: PropTypes.bool,
    isCostcodeRequired: PropTypes.bool,
  }).isRequired,
  costcodes: PropTypes.arrayOf(PropTypes.shape({})),
  fetchProjectCostcodes: PropTypes.func,
};

TimeTrackingGridWizardCostcodeStep.defaultProps = {
  costcodes: [],
  fetchProjectCostcodes: null,
};
